customElements.component = 'date-picker';

if (!customElements.get(customElements.component)) {
  const selectors = {
    year: ".js-year",
    month: ".js-month",
    day: ".js-day",
    value: ".js-date-picker-value"
  }

  class DataPicker extends HTMLElement {
    constructor() {
      super();

      this.yearSelect = this.querySelector(selectors.year);
      this.monthSelect = this.querySelector(selectors.month);
      this.daySelect = this.querySelector(selectors.day);
      this.valueInput = this.querySelector(selectors.value);

      this.updateDays = this.updateDays.bind(this);
      this.updateMonths = this.updateMonths.bind(this);

      this.init();
    }

    getDaysInMonth(year, month) {
      return new Date(year, month, 0).getDate();
    }

    updateDays() {
      const today = new Date();
      const year = +this.yearSelect.value;
      const month = +this.monthSelect.value;
      const days = this.getDaysInMonth(year, month);
      const isCurrentMonth = year === today.getFullYear() && month === (today.getMonth() + 1);

      this.daySelect.innerHTML = '';

      for (let i = 1; i <= days; i++) {
        const option = document.createElement('option');

        option.value = i;
        option.text = i;

        if (isCurrentMonth && i <= today.getDate()) {
          option.disabled = true;
        }

        this.daySelect.appendChild(option);
      }

      if (isCurrentMonth && today.getDate() < days) {
        this.daySelect.value = today.getDate() + 1;
      }
    }

    updateMonths() {
      const today = new Date();
      const selectedYear = +this.yearSelect.value;
      const isCurrentYear = selectedYear === today.getFullYear();
      const monthOptions = this.monthSelect.querySelectorAll('option');

      monthOptions.forEach(option => {
        option.disabled = isCurrentYear && +option.value < (today.getMonth() + 1);
      });

      if (isCurrentYear) {
        this.monthSelect.value = today.getMonth() + 1;
      }
    }

    updateYears() {
      const currentYear = new Date().getFullYear();

      for (let i = currentYear; i <= currentYear + 10; i++) {
        const option = document.createElement('option');

        option.value = i;
        option.text = i;
        this.yearSelect.appendChild(option);
      }
    }

    setValue() {
      const year = this.yearSelect.value;
      const month = this.monthSelect.value;
      const day = this.daySelect.value;
      const date = new Date(year, month - 1, day);

      date.setHours(12);

      this.valueInput.value = date.toISOString();
    }

    init() {
      const today = new Date();
      const tomorrow = new Date();

      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(12, 0, 0, 0);
      this.valueInput.value = tomorrow.toISOString();

      this.updateYears();
      this.yearSelect.value = today.getFullYear();
      this.updateMonths();
      this.monthSelect.value = today.getMonth() + 1;
      this.updateDays();

      this.monthSelect.addEventListener('change', () => {
        this.updateDays();
        this.setValue();
      });

      this.yearSelect.addEventListener('change', () => {
        this.updateMonths();
        this.updateDays();
        this.setValue();
      });

      this.daySelect.addEventListener('change', () => {
        this.setValue();
      });
    }
  }

  customElements.define("date-picker", DataPicker);
}
